// extracted by mini-css-extract-plugin
export default {"container":"jM-z","dimension":"kM-z","dimensionLabels":"lM-z"};